import React from 'react';
import { observer } from 'mobx-react';

import Styled from 'styled';
import SVGIcon from 'lib/images/svg-icon/svg-icon';

import ButtonView from '../button-view';
import defaultStyles from './context-button-view.scss';


@Styled(defaultStyles)
@observer
class ContextButtonView extends React.Component {
    render() {
        const { styles, label, icon, ...rest } = this.props;

        return (
            <ButtonView {...rest} styles={styles}>
                {icon ? <SVGIcon style={{image: styles.icon}} src={icon} /> : null}
                {label ? <span className={styles.label}>{label}</span> : null}
            </ButtonView>
        );
    }
}

export default ContextButtonView;
